/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.0 cego.glb T 
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

/**
 * Cego component renders a 3D model of a CEGO.
 * 
 * @component
 * @param {object} pos - The position of the CEGO model.
 * @returns {React.ReactElement} The Cego component.
 */
export function Cego(pos) {
  /**
   * Uses the useGLTF hook to load the CEGO 3D model.
   * 
   * @type {object} nodes - The nodes of the 3D model.
   * @type {object} materials - The materials of the 3D model.
   */
  const { nodes, materials } = useGLTF('/models/cego.glb')
  
  return (
    <group position={pos} dispose={null} rotation={[Math.PI/2,0,0]}>
      <mesh geometry={nodes.Cube.geometry} material={materials.Material} scale={[15.25, 114.5, 56]} />
    </group>
  )
}

/**
 * Preloads the CEGO 3D model.
 */
useGLTF.preload('/models/cego.glb')